var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.css(), _vm.css('', _vm.channel)]},[_c('audio',{class:_vm.css('audio'),attrs:{"controls":"","controlslist":"nodownload"}},[_c('source',{attrs:{"src":_vm.url,"type":"audio/mp3"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }